import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export type ForgotPasswordFormType = { email: string };

export const forgotPasswordForm: FormBuilderType<ForgotPasswordFormType> = {
  email: {
    type: "input",
    name: "email",
    label: "Email",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.email()],
    required: true,
    props: {
      keyboardType: "email-address",
    },
  },
};
